module.exports = __webpack_public_path__ + "static/media/boyAbacus.c33cc428.jpg";